<template>
  <tx-msg-box ref="dialog" :use-effect="false"
              :options="{title: title, type: 'alert', confirmButtonText: '提交', callback: bindSubmit, callbackClose: true}">
    <div class="feedback-dialog">
      <el-input class="mb10" v-model="form.content" ref="content" type="textarea"
                :placeholder="`非常感谢你反馈给我们的建议，帮助我们不断完善产品，谢谢。`" :rows="4"/>
      <div style="width:500px;"></div>
      <transition name="canvas-pos">
        <div class="canvas-pos" v-show="submitScreenshots" id="canvasPos" :style="canvasPosStyle"
             v-loading="loading"></div>
      </transition>
      <div class="mt5">
        <el-checkbox v-model="submitScreenshots">提交截图</el-checkbox>
      </div>

      <el-input class="mb10 mt10" v-model="form.contact" type="input" placeholder="请留下真实联系方式（手机、邮箱），方便我们联系你！"/>
    </div>
  </tx-msg-box>
</template>

<style lang="less">
  .feedback-dialog {
    canvas, textarea, .el-input__inner {
      border-radius: 8px;
    }

    .canvas-pos {

      canvas {
        width: 100% !important;
        height: auto !important;
        border-radius: 8px;
      }

      &-enter-active, &-leave-active {
        transition: all 0.3s;
      }

      &-enter, &-leave-to {
        height: 0 !important;
      }

      &:hover {
        cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABGdBTUEAALGPC/xhBQAAARpJREFUOBGdkr1KA0EUhTcxEkSQQIpAihQWPoedD2BnIVsZQiBVEkiR7SwtBDsJqXwBLQwEgoWNjY2FjYUQ38Ei5Oc7sBeGLTKze+Djzsyecxh2N4ryq0zkHpYQQ2H1SW5TNsxukaZzQsewACvTvIBg3eFUaABHMEv3OruBIN3icm8wZl+FZ3iBQ/AqweGW2FrlKlChV0McFsxOvaegm/T2lLzzTC/dqzaO7A1s/8GzE28Dhhj0f1jQnZ+c18CrKxxrcMO2/uK87m3AcAkrsKA7vzlvQJAmuNywrX84bwY1YBrBATyCFWj+QguCJKNCU1DZQ7r/Y55CsK5x2i2eWFcggTPIJd3Eiv5Zd3KlU3OJOQd9lVd4A5Xl1g4YG2GGhwRfegAAAABJRU5ErkJggg==) 0 17, default
      }
    }
  }
</style>

<script>
  import { formatDate } from '../../utils/time'
  import { feedbackApi } from '../../api/common'
  import { makeCancelable } from '../../utils/cancelable-promise'

  export default {
    name: 'page-htm-2-img',

    data () {
      return {
        loading: false,
        canvasPosStyle: {},
        submitScreenshots: true,
        currentTask: null,
        form: {
          content: '',
          contact: '',
          imgs: ''
        },
        title: '意见反馈'
      }
    },
    created () {
    },
    methods: {
      open () {
        let width = $(window).width()
        let height = $(window).height()
        let defWidth = 500
        let rate = defWidth / width
        let config = {
          allowTaint: false,
          useCORS: false,
          foreignObjectRenderign: true,
          width,
          height: $('body').get(0).scrollHeight,
          windowWidth: width,
          windowHeight: height,
          x: $('body,html').scrollLeft(),
          y: $('body,html').scrollTop(),
          ignoreElements (ele) {
            return $(ele).hasClass('comp-quick-aside') ||
              $(ele).hasClass('msg-box-mask') ||
              $(ele).hasClass('message-flex')
          }
        }
        let pHeight = height * rate
        this.canvasPosStyle = {
          width: defWidth + 'px',
          height: Math.min(pHeight, 400) + 'px',
          overflow: 'hidden'
        }
        $('#canvasPos').html('')
        this.$refs.dialog.open()
        if (this.currentTask) {
          this.currentTask.cancel()
          this.loading = false
        }
        this.toCanvas(config)
      },
      startDraw () {
        let defWidth = 500
        var $cnv = $('#canvasPos canvas')
        var cnvOffset = $cnv.offset()
        let winWidth = $(window).width()
        let rate = winWidth / defWidth
        var ctx = $cnv.get(0).getContext('2d')
        var paint = false
        $cnv.mousedown((e) => {
          paint = true
          ctx.beginPath()
          ctx.strokeStyle = '#e00'
          ctx.lineWidth = 4
          console.log(e, cnvOffset)
          ctx.moveTo((e.pageX - cnvOffset.left) * rate, (e.pageY - cnvOffset.top) * rate)
        })

        $cnv.mousemove((e) => {
          if (paint) {
            ctx.lineTo((e.pageX - cnvOffset.left) * rate, (e.pageY - cnvOffset.top) * rate)
            ctx.stroke()
          }
        })

        $cnv.mouseup((e) => {
          paint = false
          ctx.closePath()
        })
      },
      canvas2file (canvas, callback) {
        canvas.toBlob((blob) => {
          let file = new File([blob], formatDate(new Date(), '') + new Date().getTime() + '.png', { type: 'image/png' })
          console.log(file)
          callback(file)
        })
      },
      toCanvas (config) {
        this.loading = true
        import('html2canvas').then((html2canvas) => {
          let promise = html2canvas.default(document.body, config).then((canvas) => {
            $('#canvasPos').html(canvas)
            this.loading = false
            this.startDraw()
          }).catch(err => {
            console.log(err, 'catch')
            this.loading = false
          })
          this.currentTask = makeCancelable(promise, () => {
            this.loading = false
          })
          console.log(this.currentTask)
        })
      },
      bindSubmit (type, close) {
        // console.log(type, close)
        // return
        let vm = this
        let form = new FormData()
        if (type === 'cancel') {
          close()
          if (this.currentTask) {
            this.currentTask.cancel()
          }
          return
        }
        if (!vm.form.content) {
          vm.$notify.error({ title: '提示', message: '请输入反馈内容~' })
          vm.$refs.content.focus()
          return
        }

        function sendData (formdata) {
          feedbackApi(formdata).then(res => {
            if (res.data.status === 200) {
              vm.$notify.success({ title: '提示', message: res.data.data })
              close()
            }
          })
        }

        form.append('content', vm.form.content)
        form.append('contact', vm.form.contact)
        form.append('type', '2') // 组卷在线
        if (vm.submitScreenshots) {
          vm.canvas2file($('#canvasPos canvas').get(0), (file) => {
            form.append('imgs', file)
            sendData(form)
          })
        } else {
          sendData(form)
        }
      }
    }
  }
</script>
